import API from "./API";

class LocationPublic {
  static async search(data) {
    return API.get("/public/locations", {
      params: data
    });
  }

  static async get(id) {
    return API.get(`/public/locations/${id}`);
  }

  static async requestActivation(data) {
    return API.post(`/public/locations/request-activation`, data);
  }
}

export default LocationPublic;
